import { Card, Col, Divider, Row, Space, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  updateRenewalCoverageDate,
  updateRenewalCustomerCode,
  updateRenewalStatus,
} from "../../../store/renewalsSearch/renewalsSearchThunks";
import InlineEditableCustomerCode from "../../applications/shared/InlineEditableCustomerCode";
import InlineEditableCoverageDate from "./InlineEditableCoverageDate";
import InlineEditableStatus from "./InlineEditableStatus";
import dayjs from "dayjs";

const { Text } = Typography;

export default function RenewalMetaCard({ coverageDateAttention = 0 }) {
  const { renewalId } = useParams();
  const dispatch = useDispatch();

  const data = useSelector((state) => state.renewalsSearch.viewRenewal.data);
  const status = data?.status;

  const disabled = status === "cancelled" || status === "completed";

  const onSaveCustomerCode = (newCode) => {
    dispatch(
      updateRenewalCustomerCode({ id: renewalId, customerCode: newCode })
    );
  };

  const onSaveStatus = (newStatus) => {
    dispatch(updateRenewalStatus({ id: renewalId, status: newStatus }));
  };

  const onSaveCoverageDate = (newDate) => {
    dispatch(
      updateRenewalCoverageDate({ id: renewalId, coverageDate: newDate })
    );
  };

  const lastEdited = data?.last_updated_at
    ? `${data.last_updated_at}${data?.last_updated_by ? " • " + data.last_updated_by : ""}`
    : "—";

  return (
    <Card
      size="small"
      style={{ marginBottom: 12, background: "#fafafa" }}
      bodyStyle={{ padding: 8 }}
    >
      <Row gutter={[16, 8]} align="middle" justify="space-between">
        <Col flex="0 0 300px">
          <Space size={6}>
            <Text type="secondary" style={{ fontSize: 15 }}>
              Status:
            </Text>
            <InlineEditableStatus
              sentAt={data?.sent_at}
              value={status}
              disabled={disabled || Boolean(data?.email_delivery_state)}
              onSave={onSaveStatus}
            />
          </Space>
        </Col>

        <Col flex="0 0 375px">
          <Text type="secondary" style={{ fontSize: 15 }}>
            Coverage date:
          </Text>{" "}
          <InlineEditableCoverageDate
            value={data?.coverage_date}
            disabled={disabled}
            attention={coverageDateAttention}
            onSave={onSaveCoverageDate}
          />
        </Col>

        <Col flex="0 0 300px">
          <Text type="secondary" style={{ fontSize: 15 }}>
            Customer code:
          </Text>{" "}
          <InlineEditableCustomerCode
            disabled={disabled}
            value={data?.customer_code}
            onSave={onSaveCustomerCode}
          />
        </Col>
      </Row>
      <Divider dashed style={{ marginTop: 4, marginBottom: 4 }} />
      <Row gutter={[16, 8]} align="middle" justify="space-between">
        <Col flex="0 0 300px">
          <Space size={6}>
            <Text type="secondary" style={{ fontSize: 14 }}>
              Previous Policy Expiry:
            </Text>
            {data.previous_policy_expiry_date
              ? dayjs(data.previous_policy_expiry_date).format("MMM D, YYYY")
              : "—"}
          </Space>
        </Col>

        <Col flex="0 0 375px">
          <Text type="secondary" style={{ fontSize: 14 }}>
            Last edited:
          </Text>{" "}
          {lastEdited}
        </Col>

        <Col flex="0 0 300px">
          <Text type="secondary" style={{ fontSize: 14 }}>
            Application #:
          </Text>{" "}
          {data?.application_number ?? "—"}
        </Col>
      </Row>
    </Card>
  );
}
